"use strict";
exports.__esModule = true;
var angular = require("angular");
var efport_table_logic_1 = require("./efport-table.logic");
var EFPortTableController = /** @class */ (function () {
    function EFPortTableController($scope, $timeout) {
        var _this = this;
        this.$onChanges = function () {
            _this.gridOptions = null;
            if (!_this.tableData) {
                return;
            }
            _this.$timeout(function () {
                var dataCopy = JSON.parse(JSON.stringify(_this.tableData));
                var inputData = dataCopy.inputData, settings = dataCopy.settings;
                if (settings) {
                    _this.decimals = settings.decimals;
                }
                if (inputData) {
                    _this.gridOptions = efport_table_logic_1.EFPortTable.generateGridOptions(dataCopy, _this.decimals);
                    _this.$timeout();
                }
            });
        };
        var ctrl = this;
        this.$timeout = $timeout;
        $scope.$on('export:csv', function (event, args, callback) {
            var csv = ctrl.exportCsv(args.filename, args.csvFormat, args.skipSave || false, args.terminology);
            if (callback) {
                callback(csv);
            }
        });
    }
    EFPortTableController.prototype.exportCsv = function (filename, csvFormat, skipSave, terminology) {
        var mainCsv = efport_table_logic_1.EFPortTable.generateCsv(this.gridOptions.main, csvFormat, terminology);
        var siblingCsv = efport_table_logic_1.EFPortTable.generateCsv(this.gridOptions.sibling, csvFormat, terminology);
        var csv = siblingCsv ? this.tableData.mainNodeName.concat('\n').concat(mainCsv).concat('\n\nCompare To:\n').concat(this.tableData.siblingNodeName).concat('\n').concat(siblingCsv) : mainCsv;
        if (!skipSave) {
            var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
            saveAs(blob, filename);
        }
        return csv;
    };
    return EFPortTableController;
}());
angular.module('smartorg.r6.cmpts.efportTable', [
    'ui.grid',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
]).component("efportTable", {
    template: require("./efport-table.component.html"),
    styles: [require('./efport-table.component.css')],
    controller: EFPortTableController,
    bindings: {
        tableData: '<',
        showAlert: '&?'
    }
});
module.exports = 'smartorg.r6.cmpts.efportTable';
//# sourceMappingURL=efport-table.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/efport-table/efport-table.component.js